import { API_HOSTNAME } from "../../../config"

export const wadoURL = `${API_HOSTNAME}api/share/dicom`
